<template>
  <div class="position-relative login-page">
    <div class="d-flex align-content-center flex-wrap justify-content-center" style="height: 100vh">
      <b-card class="mb-2 text-center shadow login-container mx-2 login-card-border" bg-variant="020f40" align="center">
        <b-card-text>
          <div class="logo-login">
            <img class="logo-image" src="../assets/img/logo_branca.png" alt="Logo GeoFiber" />
          </div>
          <div class="login-content">
            <slot name="body"></slot>
          </div>
          <div class="login-footer">
            <div class="system-version">${MAP-VERSION-MAP}</div>
            <p class="copyright">
              © {{ currentYear }}
              <a href="https://geocode.com.br" target="_blank" class="geocode-link">Geocode Sistemas. Todos os direitos reservados</a>
            </p>
          </div>
        </b-card-text>
      </b-card>
      <div class="social-icons-container">
        <SocialIcons />
      </div>
      <slot name="movie"></slot>
    </div>
  </div>
</template>

<script>
import SocialIcons from "../components/extra/SocialIcons";
export default {
  name: "LoginLayout",
  components: {
    SocialIcons,
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
.login-page {
  background: linear-gradient(135deg, #020f40 0%, #0188f8 100%);
  font-family: 'Roboto', 'Helvetica Neue', sans-serif;
  min-height: 100vh;
  width: 100%;
  position: fixed;
  /* Fixa o elemento para cobrir toda a tela */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  /* Permite rolagem se o conteúdo for maior que a tela */
}

.login-container {
  color: #ffffff;
  padding: 2.5em;
  border-radius: 15px;
  background-color: #020f40 !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2) !important;
  max-width: 100%;
  width: 500px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: 1px solid #0188f8 !important;
  animation: fadeIn 0.5s ease-out;
}

.login-container::before {
  content: '';
  position: absolute;
  top: -50px;
  right: -50px;
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  z-index: 0;
}

.logo-login {
  text-align: center;
  margin-bottom: 2em;
  position: relative;
}

.logo-image {
  width: 240px;
  height: auto;
  transition: transform 0.3s ease;
  filter: drop-shadow(0 5px 10px rgba(0, 0, 0, 0.1));
  padding-bottom: 0.75rem;
  margin-top: 0.5rem;
}

.logo-image:hover {
  transform: scale(1.05);
}

.login-content {
  position: relative;
  z-index: 1;
}

.login-footer {
  margin-top: 2em;
  text-align: center;
}

.system-version {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9em;
  margin-top: 0.25em;
  font-weight: 500;
}

.copyright {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8em;
  margin-top: 0.5em;
  margin-bottom: 0;
}

.social-icons-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 1em;
}

._input {
  font-size: 16px;
  background-color: transparent;
  padding: 10px;
  height: 40px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 3px;
  color: #dcddde;
  box-sizing: border-box;
  border: 1px solid #212327;
  transition: all 0.3s ease;
}

._input:focus {
  border-color: #0188f8;
  box-shadow: 0 0 0 2px rgba(1, 136, 248, 0.25);
  outline: none;
}

.label-login {
  font-weight: 600;
  color: #fff;
  font-size: 12px;
  text-transform: uppercase;
  margin-bottom: 0.5em;
  display: block;
}

.primary-color:hover {
  color: #0188f8;
  text-decoration: none;
}

.primary-color {
  color: #fff;
  transition: all 0.3s ease;
}

.gray-color {
  color: #8e9297;
}

.fw-500 {
  font-weight: 500;
}

@media only screen and (max-width: 770px) {
  .h-440 {
    display: none;
  }

  .login-container {
    background-color: transparent !important;
    border: 0px !important;
    box-shadow: 0px 0px 0px black !important;
  }

  .login-card-border {
    border: 1px solid transparent !important;
  }
}

/* Animações */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estilos para elementos dentro do slot */
:deep(.btn-primary) {
  background-color: #0188f8;
  border-color: #0188f8;
  padding: 10px 15px;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

:deep(.btn-primary)::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: 0.5s;
}

:deep(.btn-primary):hover {
  background-color: #0099ff;
  border-color: #0099ff;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

:deep(.btn-primary):hover::after {
  left: 100%;
}

:deep(.form-group) {
  margin-bottom: 1.5em;
  animation: fadeIn 0.5s ease-out;
  animation-fill-mode: both;
}

:deep(.form-group:nth-child(1)) {
  animation-delay: 0.1s;
}

:deep(.form-group:nth-child(2)) {
  animation-delay: 0.2s;
}

:deep(.form-control:focus) {
  border-color: #0188f8;
  box-shadow: 0 0 0 0.2rem rgba(1, 136, 248, 0.25);
}

@media only screen and (max-width: 770px) {
  .h-440 {
    display: none;
  }

  .login-container {
    background-color: #020f40 !important;
    border: 0px !important;
    box-shadow: none !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 1em !important;
    margin: 0 !important;
    border-radius: 0 !important;
  }

  .login-card-border {
    border: 1px solid transparent !important;
  }

  /* Ajustes para os campos de input */
  ._input {
    height: 45px;
    font-size: 16px;
    padding: 12px;
  }

  /* Aumenta o tamanho dos botões para facilitar o toque */
  :deep(.btn) {
    padding: 12px 15px;
    font-size: 16px;
  }

  /* Ajusta o espaçamento entre os elementos */
  :deep(.form-group) {
    margin-bottom: 1.2em;
  }

  /* Ajusta o tamanho do logo para dispositivos móveis */
  .logo-image {
    width: 200px;
    margin-top: 0;
    padding-bottom: 0.5rem;
  }

  /* Ajusta o container principal para ocupar toda a tela */
  .login-page {
    padding: 0;
    background: #020f40;
  }

  /* Ajusta o layout para centralizar melhor o conteúdo */
  .d-flex.align-content-center {
    padding: 0;
  }

  /* Ajusta o rodapé para ter menos espaço */
  .login-footer {
    margin-top: 1.5em;
  }

  /* Ajusta o container de ícones sociais */
  .social-icons-container {
    margin-top: 0.5em;
  }
}

/* Para telas muito pequenas, ajusta ainda mais os tamanhos */
@media only screen and (max-width: 360px) {
  .login-container {
    padding: 1em !important;
  }

  .logo-image {
    width: 180px;
  }

  ._input {
    height: 42px;
    padding: 10px;
  }
}
</style>
